import React, { useState } from 'react';
import TextInput from '../../../Shared/TextInput/TextInput';
import Footer from '../Assets/footer';
import MultipleAccountsIcon from '../Assets/SVG/multipleAccountsIcon';
import { rolesKeys } from '../Assets/variables';
import RadioInput from '../../../Shared/RadioInput/RadioInput';
import '../../../Shared/RadioInput/RadioInput.scss';
const ChoosePrivate = (props) => {
  const [isError, setError] = useState(null);
  const [selectedMode, setMode] = useState(null);

  const continueToLobby = () => {
    if (selectedMode) {
      props.onclick(selectedMode);
    } else {
      setError('אנא בחר משתמש');
    }
  };

  return (
    <div className='screenContainer'>
      <MultipleAccountsIcon />
      <h3 className='heading withSecondary'>נראה שיש לך יותר מחשבון אחד</h3>
      <h4 className='secondaryHeading'>לאיזה מהם להתחבר?</h4>
      <div className='radio-input-container'>
        <RadioInput
          checked={selectedMode === rolesKeys.SUBSCRIBER}
          onChange={() => {
            setMode(rolesKeys.SUBSCRIBER);
          }}
          label={'מנוי הסלולר שלי'}
          name='SelectedMode'
          value={rolesKeys.SUBSCRIBER}
          id='cellularSelection'
        />
        <RadioInput
          checked={selectedMode === rolesKeys.PRIVATE}
          onChange={() => setMode(rolesKeys.PRIVATE)}
          label={'חשבון נוסף'}
          name='SelectedMode'
          value={rolesKeys.PRIVATE}
          id='contactSelection'
        />
      </div>

      <Footer onclick={continueToLobby} stage={props.stage} />
    </div>
  );
};

export default ChoosePrivate;
